import { cn } from '@/lib/ui/utils';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';

type CmsSurfaceVariant =
  | 'card'
  | 'card-strong'
  | 'panel'
  | 'contrast'
  | 'media'
  | 'form';

const variantClassMap: Record<CmsSurfaceVariant, string> = {
  card: 'cms-surface-card',
  'card-strong': 'cms-surface-card cms-surface-card-strong',
  panel: 'cms-surface-panel',
  contrast: 'cms-surface-contrast',
  media: 'cms-surface-media',
  form: 'cms-surface-form',
};

type CmsSurfaceProps<T extends ElementType> = {
  as?: T;
  variant?: CmsSurfaceVariant;
  interactive?: boolean;
  className?: string;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, 'className' | 'children'>;

export function CmsSurface<T extends ElementType = 'div'>({
  as,
  variant = 'card',
  interactive = false,
  className,
  children,
  ...props
}: CmsSurfaceProps<T>) {
  const Component = (as ?? 'div') as ElementType;

  return (
    <Component
      className={cn(
        'cms-width-guard',
        variantClassMap[variant],
        interactive && 'cms-interactive-surface',
        className
      )}
      {...props}
    >
      {children}
    </Component>
  );
}
